import { addQueryStrings } from "@userFrontend/utils/addQueryStrings";
import { useCallback, useEffect, useState, type MouseEvent, type KeyboardEvent } from "react";

type HandleClickLinkOptions = {
  url: string;
  query: string;
  event: MouseEvent<HTMLElement> | KeyboardEvent<HTMLElement>;
};

export const useTransitionWithQuery = () => {
  const [isClicked, setIsClicked] = useState(false);

  useEffect(() => {
    const resetClickFlag = () => {
      setIsClicked(false);
    };
    window.addEventListener("pageshow", resetClickFlag);
    return () => {
      window.removeEventListener("pageshow", resetClickFlag);
    };
  }, []);

  const handleClickLink = useCallback(
    ({ url, query, event }: HandleClickLinkOptions) => {
      if (isClicked) return;
      event.preventDefault();
      setIsClicked(true);
      window.location.href = addQueryStrings(url, query);
    },
    [isClicked],
  );

  return { handleClickLink };
};
